import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';

import {
  checkStatus,
} from '../../actions';

import {
  addAlert,
  dismissAlert,
  ALERT_TYPE,
} from '../../actions/alerts';

import imgWarning from '../../assets/images/warning.svg';

import './index.css';

export const getAlertByType = (type) => {
  let alert = null;
  switch (type) {
    case ALERT_TYPE.SERVER_UNAVAILABLE:
      alert = (
        <div styleName="alertRow" key={uniqueId()}>
          <img src={imgWarning} alt="Warning" styleName="alertImg" />
          <div styleName="alertMessage">
            My IPO server is currently unavailable. Please try again later.
          </div>
        </div>
      );
      break;
    // no default
  }
  return alert;
};

export class UnconnectedAlerts extends Component {
  componentDidMount() {
    this.props.checkStatus({ retryIfFailed: true });
    this.onServiceAvailableStatus(this.props.status);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.status !== nextProps.status) {
      this.onServiceAvailableStatus(nextProps.status);
    }
  }

  onServiceAvailableStatus = (status) => {
    if (status !== 'ok') {
      // Only add alert if no similar alert is visible
      if (!this.props.alerts.find(alert => (
        alert.type === ALERT_TYPE.SERVER_UNAVAILABLE
        && alert.visible))) {
        this.props.addAlert(ALERT_TYPE.SERVER_UNAVAILABLE);
      }
    } else {
      this.props.alerts.forEach((alert) => {
        if (alert.type === ALERT_TYPE.SERVER_UNAVAILABLE && alert.visible) {
          this.props.dismissAlert(alert.id);
        }
      });
    }
  }

  render() {
    const { alerts, currentAccount } = this.props;
    const visibleAlerts = alerts.filter(alert => alert.visible);
    const redAlerts = visibleAlerts.filter(alert => alert.type === ALERT_TYPE.SERVER_UNAVAILABLE);
    return visibleAlerts.length > 0 && (
      <div>
        {
          redAlerts.length > 0 && (
            <div styleName="alertRed">
              {redAlerts.map(alert => (getAlertByType(alert.type, currentAccount)))}
            </div>)
        }
      </div>
    );
  }
}


const mapStateToProps = state => ({
  alerts: get(state, 'alerts', []),
  status: get(state, 'serviceStatus.status', 'ok'),
  currentAccount: get(state, 'currentAccount', null),
});

const mapDispatchToProps = {
  checkStatus,
  addAlert,
  dismissAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedAlerts);



// WEBPACK FOOTER //
// ./src/components/Alerts/index.js